/**
 * Application-wide constants
 */

// API Configuration - reads from window.BONZAI_API when embedded
export const API_BASE_URL = window.BONZAI_API || 'http://localhost:6767';

// WebSocket URL - convert http(s) to ws(s)
export const WS_BASE_URL = API_BASE_URL.replace(/^http/, 'ws');

// Asset base URL - use CDN when embedded, relative paths for local dev
export const ASSET_BASE_URL = window.BONZAI_API ? 'https://bonzai.dev' : '';
export const API_ENDPOINTS = {
  LIST: '/list',
  READ: '/read',
  WRITE: '/write',
  WRITE_DIR: '/write_dir',
  DELETE: '/delete',
  MOVE: '/move',
  OPEN_CURSOR: '/open-cursor',
  SHUTDOWN: '/shutdown',
  DETECT_CLAUDE: '/detect-claude',
  SCAN_STANDARDS: '/scan_standards',
  GIT_BURNS: '/git/burns',
  GIT_CHECKOUT: '/git/checkout',
};

// Server Configuration
export const SERVER_CHECK_INTERVAL = 5000; // milliseconds
export const SERVER_STATUS_DELAY = 1000; // milliseconds for shutdown delay

// File Operations
export const CURSOR_STATUS_TIMEOUT = 3000; // milliseconds
export const MIN_DISTANCE_FOR_CONNECTION = 150; // pixels

// File Extensions
export const CODE_FILE_EXTENSIONS = [
  'js', 'jsx', 'ts', 'tsx', 'py', 'java', 'cpp', 'c', 
  'html', 'css', 'json', 'xml', 'md', 'sh', 'yaml', 'yml'
];

// File/Directory Ignore Patterns
export const INDEX_IGNORE_FOLDERS = ['__pycache__', '.venv', 'node_modules', '.git', 'codeflow', 'bonzai'];
export const INDEX_IGNORE_FILES = ['package.json', 'package-lock.json', '.gitignore', '.DS_Store'];

// IDE Configuration
export const IDE_OPTIONS = [
  { name: 'Cursor', icon: '⌘' },
  { name: 'VS Code', icon: '📝' },
  { name: 'WebStorm', icon: '🌐' },
  { name: 'Sublime Text', icon: '📋' },
  { name: 'Vim', icon: '🖥️' }
];
export const DEFAULT_IDE = 'Cursor';
export const IDE_STORAGE_KEY = 'bonzai_selected_ide';
